import { QueryFunctionContext } from "@tanstack/react-query";

export function getParams<T>(context: QueryFunctionContext): T {
  return context.queryKey[1] as unknown as T;
}
